import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../../environment/environment';
import { BehaviorSubject, finalize, Observable, tap } from 'rxjs';
import {
    ApiResponse,
    Pagination,
    PaginationFilterInterface,
    PaginationFilterModel,
} from '../../models/api-response.model';
import { NotificationInterface, UnreadNotificationCountInterface } from '../../models/notification.model';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    notificationRefreshOnRead: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    notificationDataSubject = new BehaviorSubject<NotificationInterface[]>([]);
    notificationData$ = this.notificationDataSubject.asObservable();
    isLoadingSubject = new BehaviorSubject<boolean>(false);
    isLoading$ = this.isLoadingSubject.asObservable();
    apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/notification`;

    constructor(private httpClient: HttpClient) {}

    public getNotificationCount(): Observable<ApiResponse<UnreadNotificationCountInterface>> {
        return this.httpClient.get<ApiResponse<UnreadNotificationCountInterface>>(`${this.apiRoute}/unread-count`);
    }

    public getNotificationList(
        filter: PaginationFilterInterface,
    ): Observable<ApiResponse<Pagination<NotificationInterface[]>>> {
        return this.httpClient.post<ApiResponse<Pagination<NotificationInterface[]>>>(`${this.apiRoute}`, filter);
    }

    public refreshNotifications(): void {
        if (this.isLoadingSubject.getValue()) {
            return;
        }

        this.isLoadingSubject.next(true);

        const filter: PaginationFilterModel = new PaginationFilterModel({
            paging: false,
        } as PaginationFilterInterface);

        this.getNotificationList(filter)
            .pipe(
                tap((resp) => {
                    this.notificationDataSubject.next(resp.result.data);
                }),
                finalize(() => {
                    this.isLoadingSubject.next(false);
                }),
            )
            .subscribe();
    }

    public markAllNotificationAsRead(): Observable<ApiResponse<boolean>> {
        return this.httpClient.post<ApiResponse<boolean>>(`${this.apiRoute}/all/read`, null);
    }

    public markNotificationAsRead(id: number): Observable<ApiResponse<boolean>> {
        return this.httpClient.post<ApiResponse<boolean>>(`${this.apiRoute}/${id}/read`, null);
    }
}
